module.exports = __webpack_public_path__ + "img/briefcase_icon.996eb216.png";